import { FormValues } from '@/components/survey/SurveyModel/types/commonTypes'

export interface FormDataState {
    [key: string]: FormValues
}

const formData = (function () {
    const formData: FormDataState = {}
    const unChangedData: FormDataState = {}

    const setFormData = (name: string, value: FormValues) => {
        formData[name] = value
    }

    const getFormDataByFieldName = (name: string) => {
        return formData[name]
    }

    const setUnChangedData = (name: string, value: FormValues) => {
        unChangedData[name] = value
    }

    const getUnChangedDataaByFieldName = (name: string) => {
        return unChangedData[name]
    }

    return {
        setFormData: setFormData,
        getFormDataByFieldName: getFormDataByFieldName,
        setUnChangedData: setUnChangedData,
        getUnChangedDataaByFieldName: getUnChangedDataaByFieldName,
    }
})()

export default formData
